import React from 'react';

type Props = {
  message?: string;
};

export const EmailMessage: React.FC<Props> = ({ message }): JSX.Element => {
  const attrs = {
    wrapper: { className: 'message' },
    body: { className: 'message__body' },
  };

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.body}> {message}</div>
    </div>
  );
};
